import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  TextField,
  Switch,
  FormControlLabel,
  Box,
  Divider
} from '@mui/material';

export default function FeatureFlagsDialog({ open, onClose, user, onSave }) {
  const [flags, setFlags] = useState({
    isAdmin: false,
    enableLakeOverrides: false,
    enableDebug: false,
    aiPreReleaseVersion: '',
    insightPanelsVersion: '',
    aiVoiceVersion: '',
    chatTabVersion: '',
    manageSubscriptionsVersion: ''
  });
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    if (user?.featureFlags) {
      setFlags({
        isAdmin: user.featureFlags.isAdmin || false,
        enableLakeOverrides: user.featureFlags.enableLakeOverrides || false,
        enableDebug: user.featureFlags.enableDebug || false,
        aiPreReleaseVersion: user.featureFlags.aiPreReleaseVersion || '',
        insightPanelsVersion: user.featureFlags.insightPanelsVersion || '',
        aiVoiceVersion: user.featureFlags.aiVoiceVersion || '',
        chatTabVersion: user.featureFlags.chatTabVersion || '',
        manageSubscriptionsVersion: user.featureFlags.manageSubscriptionsVersion || ''
      });
      setSelectedUser(user);
    }
  }, [user]);


  const handleSave = () => {
    onSave(selectedUser, flags);
  };

  const handleChange = (event) => {
    const { name, value, checked } = event.target;
    setFlags(prev => ({
      ...prev,
      [name]: event.target.type === 'checkbox' ? checked : value
    }));
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Feature Flags</DialogTitle>
      <DialogContent>
        <Box sx={{ p: 1 }}>
          <Grid container spacing={3}>
            {/* Toggles */}
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={flags.isAdmin}
                        onChange={handleChange}
                        name="isAdmin"
                      />
                    }
                    label="Is Admin"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={flags.enableLakeOverrides}
                        onChange={handleChange}
                        name="enableLakeOverrides"
                      />
                    }
                    label="Enable Lake Overrides"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={flags.enableDebug}
                        onChange={handleChange}
                        name="enableDebug"
                      />
                    }
                    label="Enable Debug"
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Divider />
            </Grid>

            {/* Version inputs */}
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    fullWidth
                    label="AI Pre Release Version"
                    name="aiPreReleaseVersion"
                    value={flags.aiPreReleaseVersion}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    fullWidth
                    label="Insight Panels Version"
                    name="insightPanelsVersion"
                    value={flags.insightPanelsVersion}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    fullWidth
                    label="AI Voice Version"
                    name="aiVoiceVersion"
                    value={flags.aiVoiceVersion}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    fullWidth
                    label="Chat Tab Version"
                    name="chatTabVersion"
                    value={flags.chatTabVersion}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <TextField
                    fullWidth
                    label="Manage Subscriptions Version"
                    name="manageSubscriptionsVersion"
                    value={flags.manageSubscriptionsVersion}
                    onChange={handleChange}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSave} variant="contained" color="primary">
          Save Changes
        </Button>
      </DialogActions>
    </Dialog>
  );
}
